<template>
	<div>
		<modal ref="modal-assinatura-eletronica" name="modal-assinatura-eletronica">
			<div class="row">
				<div class="col-md-4 col-xs-12 text-center">
					<span
						class="fa-stack fa-lg modal-assinatura-eletronica__icon-assinatura"
						:class="{
							'modal-assinatura-eletronica__icon-assinatura--mobile': _isMobile
						}"
					>
						<i class="fa fa-circle fa-stack-2x"></i>
						<i class="fa fa-lock fa-stack-1x fa-inverse"></i>
					</span>
				</div>

				<div class="col-md-8 col-xs-12">
					<h3
						class="modal-assinatura-eletronica__form-titulo"
						:class="{'text-center': _isMobile}"
					>
						{{ _traducao('global', 'assinatura').toUpperCase() }}
					</h3>

					<div class="row" v-show="ativarAssinaturaLogin">
						<div
							class="col-xs-12 form-group modal-assinatura-eletronica__form-login-btn-group"
						>
							<label
								>{{
									_traducao('global', 'desejaAdicionarAssinaturaPorLogin')
								}}?</label
							>
							<div class="btn-group print-button-group" role="group">
								<flSimNao v-model="usarLogin" />
							</div>
						</div>
					</div>

					<div
						class="form-group"
						:class="{'has-error': erro.login !== ''}"
						v-show="ativarAssinaturaLogin && usarLogin"
					>
						<label for="modal-assinatura-eletronica-login">* Login: </label>
						<input
							:id="'modal-assinatura-eletronica-login' + Math.random()"
							class="form-control input-sm"
							type="text"
							v-model="form.login"
						/>
						<p class="help-block" v-show="erro.login !== ''">
							{{ erro.login }}
						</p>
					</div>

					<div
						class="form-group"
						:class="{'has-error': erro.assinatura !== ''}"
					>
						<label for="modal-assinatura-eletronica-assinatura"
							>* {{ _traducao('global', 'digiteSuaAssinatura') }}:
						</label>
						<div
							class="fa icone-senha"
							:class="iconClassInputAssinatura"
							:title="_traducao('global', 'cliqueParaVerAAssinatura')"
							@click="inputSenhaAtivo = !inputSenhaAtivo"
							aria-hidden="true"
						></div>
						<input
							:id="'modal-assinatura-eletronica-assinatura' + Math.random()"
							ref="input-assinatura"
							:type="typeInputAssinatura"
							v-model="form.assinatura"
							class="form-control input-sm"
						/>
						<p class="help-block" v-show="erro.assinatura !== ''">
							{{ erro.assinatura }}
						</p>
					</div>

					<p
						class="modal-assinatura-eletronica__form-mensagem-erro"
						v-show="erro_confirmacao_assinatura"
					>
						<i class="fa fa-exclamation-circle" aria-hidden="true"></i>
						{{ erro_confirmacao_assinatura }}
					</p>
				</div>
			</div>

			<hr class="modal-assinatura-eletronica__separador" />
			<div class="row">
				<div
					class="col-xs-12 col-sm-6 modal-assinatura-eletronica__footer-left-btn-group"
				>
					<button
						v-show="existeModalAnterior"
						type="button"
						class="btn btn-default modal-assinatura-eletronica__footer-left-btn--voltar"
						@click="voltarParaModalAnterior"
					>
						<i class="fa fa-undo" aria-hidden="true"></i>
						{{ _traducao('global', 'voltar').toUpperCase() }}
					</button>

					<button class="btn btn-default" type="button" @click="fecharModal">
						<i class="fa fa-times"></i>
						{{ _traducao('global', 'fechar').toUpperCase() }}
					</button>
				</div>

				<div
					class="col-xs-12 col-sm-6 modal-assinatura-eletronica__footer-right-btn-group"
				>
					<button class="btn btn-success" type="button" @click="clickAssinar">
						<i class="fa fa-check"></i>
						{{ _traducao('global', 'assinar').toUpperCase() }}
					</button>
				</div>
			</div>
		</modal>
	</div>
</template>

<script>
import Teclado from './components/teclado.vue'

export default {
	name: 'ModalAssinaturaEletronica',

	components: {
		Teclado
	},

	props: {
		retornaSenha: {
			type: Boolean,
			required: false,
			default: false
		},

		existeModalAnterior: {
			type: Boolean,
			required: false,
			default: false
		},

		ativarAssinaturaLogin: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	data() {
		return {
			form: {
				login: '',
				assinatura: ''
			},
			erro: {
				login: '',
				assinatura: ''
			},
			usarLogin: false,
			qtdTentativas: 0,
			texto: '',
			erro_confirmacao_assinatura: '',
			inputSenhaAtivo: true,
			data: {},
			loadText: '',
			token: ''
		}
	},

	computed: {
		typeInputAssinatura() {
			return this.inputSenhaAtivo ? 'password' : 'text'
		},

		iconClassInputAssinatura() {
			return {
				'fa-eye-slash': !this.inputSenhaAtivo,
				'fa-eye': this.inputSenhaAtivo
			}
		}
	},

	methods: {
		abrirModalAssinaturaEletronica() {
			this.$refs['modal-assinatura-eletronica'].modalShow(40)
		},

		fecharModalAssinaturaEletronica() {
			this.$refs['modal-assinatura-eletronica'].modalHide()
		},

		adicionarCaractereNaAssinatura(caractere) {
			this.form.assinatura += caractere
		},

		apagarUltimoCaractereNaAssinatura() {
			this.form.assinatura = this.form.assinatura.substring(
				0,
				this.form.assinatura.length - 1
			)
		},

		limparAssinatura() {
			this.form.assinatura = ''
		},

		carregaAssinatura(data, texto) {
			this.usarLogin = false
			this.qtdTentativas = 1
			this.form.assinatura = ''
			this.form.login = ''
			this.data = data
			this.erro.assinatura = ''
			this.erro.login = ''
			this.erro_confirmacao_assinatura = ''
			this.abrirModalAssinaturaEletronica()
			this.loadText = this._traducao('global', 'assinando')
			if (!_.isNil(texto)) {
				this.loadText = texto
			}

			setTimeout(() => this.$refs['input-assinatura'].focus(), 600)
		},

		carregaAssinaturaExterna(data, token) {
			this.usarLogin = false
			this.qtdTentativas = 1
			this.form.assinatura = ''
			this.form.login = ''
			this.data = data
			this.token = token
			this.erro.assinatura = ''
			this.erro.login = ''
			this.erro_confirmacao_assinatura = ''
			this.abrirModalAssinaturaEletronica()
			this.loadText = this._traducao('global', 'assinando')

			setTimeout(() => this.$refs['input-assinatura'].focus(), 600)
		},

		voltarParaModalAnterior() {
			this.$emit('abrir-modal-anterior')
			this.fecharModal()
		},

		fecharModal() {
			this.fecharModalAssinaturaEletronica()
			this.$emit('fechou')
		},

		//LOOP ASSINATURA DIARIO DE BORDO OPERADOR
		assinar(callback, data, senha, text) {
			if (text != '') {
				window.bus.$emit('load-in', {text: text})
			}

			let dt = {
				id_usuario: window.$sessao.getId(),
				assinatura: senha,
				data: data,
				tentativas: 1
			}

			this._httpPost('Assinatura/assinar', dt, (response) => {
				if (text != '') {
					window.bus.$emit('load-out')
				}

				if (response._request && response._status) {
					callback({assinatura: response.lista, data: data})
				}
			})
		},

		clickAssinar() {
			if (this.validarForm()) {
				if (this.token) {
					this.confirmarAssinatura(true)
				} else {
					this.confirmarAssinatura()
				}
			}
		},

		confirmarAssinatura(assinatura_externa = false) {
			window.bus.$emit('load-in', {text: this.loadText})

			let data = {
				id_usuario: assinatura_externa
					? this.data.id_usuario
					: window.$sessao.getId(),
				assinatura: this.form.assinatura,
				data: this.data,
				tentativas: this.qtdTentativas
			}

			if (this.ativarAssinaturaLogin && this.usarLogin) {
				data = {...data, login: this.form.login}
			}

			this._httpPost(
				'Assinatura/assinar',
				data,
				(response) => {
					window.bus.$emit('load-out')

					if (response._request) {
						if (response._status) {
							this.fecharModalAssinaturaEletronica()
							if (this.retornaSenha) {
								this.$emit('assinado', {
									assinatura: response.lista,
									data: this.data,
									senha: this.form.assinatura
								})
							} else {
								this.$emit('assinado', {
									assinatura: response.lista,
									data: this.data
								})
							}
						} else {
							this.erro_confirmacao_assinatura = response.mensagem
							this.qtdTentativas += 1
						}
					}
				},
				assinatura_externa ? this.token : null
			)
		},

		validarForm() {
			let passou = true

			if (
				this.ativarAssinaturaLogin &&
				this.usarLogin &&
				this.form.login === ''
			) {
				passou = false
				this.erro.login = this._traducao('global', 'esseCampoObrigatorio')
			} else {
				this.erro.login = ''
			}

			if (this.form.assinatura === '') {
				passou = false
				this.erro.assinatura = this._traducao('global', 'esseCampoObrigatorio')
			} else {
				this.erro.assinatura = ''
			}

			return passou
		}
	}
}
</script>

<style scoped>
.modal-assinatura-eletronica__icon-assinatura {
	margin-top: 63px;
	font-size: 76px;
	color: #2196f3;
	opacity: 0.7;
}

.modal-assinatura-eletronica__icon-assinatura--mobile {
	margin-top: 0px;
	font-size: 50px;
}

.modal-assinatura-eletronica__form-titulo {
	color: #2196f3;
	margin-top: 10px;
}

.modal-assinatura-eletronica__form-login-btn-group {
	display: flex;
	flex-flow: column nowrap;
}

.modal-assinatura-eletronica__form-mensagem-erro {
	color: #a94442;
	margin-top: 15px;
}

.modal-assinatura-eletronica__separador {
	margin-top: 20px;
	margin-bottom: 10px;
}

.modal-assinatura-eletronica__footer-left-btn-group {
	display: flex;
}

.modal-assinatura-eletronica__footer-right-btn-group {
	display: flex;
	justify-content: flex-end;
}

.modal-assinatura-eletronica__footer-left-btn--voltar {
	margin-right: 5px;
}

@media screen and (max-width: 991px) {
	.modal-assinatura-eletronica__icon-assinatura {
		margin-top: 0;
	}

	.modal-assinatura-eletronica__footer-left-btn-group {
		flex-flow: column;
		align-items: stretch;
		margin-bottom: 5px;
	}

	.modal-assinatura-eletronica__footer-right-btn-group {
		flex-flow: column;
		align-items: stretch;
	}

	.modal-assinatura-eletronica__footer-left-btn--voltar {
		margin-right: 0;
		margin-bottom: 5px;
	}
}
</style>